module.exports = __webpack_public_path__ + "static/media/PATS_4-1267w.63a1e381.png";